import { createContext, useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import ParentalCommunicationsHome from "../views/ParentalCommunicationsHome";
import MySubjects from "../views/MySubjects";
import MyExamCycles from "../views/MyExamCycles";
import { callApi } from "../Helpers";


export default function ParentalCommunications(props) {

	const appContext = useContext(AppContext);
	

	const [view, setView] = useState(null);
	

	async function init() {
		//run initializations here
		
	}

	

	function getView() {
		if (
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ParentalCommunicationsHome />
		} 

		return null;
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		const _view = getView();
		if (_view) {
			setView(_view);
		}
	}, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem])

	
	//return desired view
	return view;
}